import { render } from "./SpecimenPicker.vue?vue&type=template&id=cbaa26ac&scoped=true&ts=true"
import script from "./SpecimenPicker.vue?vue&type=script&lang=ts"
export * from "./SpecimenPicker.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\nyffeler\\IdeaProjects\\data_tools\\Branches\\data_tools\\131\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbaa26ac"]])

export default __exports__